class JsInstagram extends HTMLElement {
  connectedCallback() {
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.maxPlaying = Number(this.dataset.maxPlaying || 4);
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.shouldAutoplay = this.autoplayEnabled && !this.reduceMotion;
    this.ratios = new Map();

    this.players = Array.from(this.querySelectorAll('video-media'));

    if (!this.shouldAutoplay) {
      this.players.forEach((player) => player.pause());
    }

    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });
    this.players.forEach((player) => this.observer.observe(player));

    this.onHoverEnter = (event) => {
      if (this.reduceMotion) return;
      const player = event.currentTarget.querySelector('video-media');
      if (player && this.isShown(player)) player.play();
    };

    this.onHoverLeave = (event) => {
      const player = event.currentTarget.querySelector('video-media');
      if (!player) return;
      if (!this.shouldAutoplay) {
        player.pause();
        return;
      }
      this.syncPlayback();
    };

    this.items = Array.from(this.querySelectorAll('.js-instagram__item--video'));
    this.items.forEach((item) => {
      item.addEventListener('mouseenter', this.onHoverEnter);
      item.addEventListener('mouseleave', this.onHoverLeave);
    });

    this.desktopQuery = window.matchMedia('(min-width: 1000px)');
    this.onBreakpoint = () => {
      window.requestAnimationFrame(() => this.syncPlayback());
    };

    if (typeof this.desktopQuery.addEventListener === 'function') {
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
    } else if (typeof this.desktopQuery.addListener === 'function') {
      this.desktopQuery.addListener(this.onBreakpoint);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.items?.forEach((item) => {
      item.removeEventListener('mouseenter', this.onHoverEnter);
      item.removeEventListener('mouseleave', this.onHoverLeave);
    });

    if (!this.desktopQuery) return;

    if (typeof this.desktopQuery.removeEventListener === 'function') {
      this.desktopQuery.removeEventListener('change', this.onBreakpoint);
    } else if (typeof this.desktopQuery.removeListener === 'function') {
      this.desktopQuery.removeListener(this.onBreakpoint);
    }
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
    });
    this.syncPlayback();
  }

  isShown(el) {
    return el.offsetParent !== null;
  }

  syncPlayback() {
    if (!this.shouldAutoplay) {
      this.players.forEach((player) => player.pause());
      return;
    }

    const ranked = this.players
      .map((player) => ({
        player,
        shown: this.isShown(player),
        ratio: this.ratios.get(player) || 0
      }))
      .filter((item) => item.shown && item.ratio >= 0.4)
      .sort((a, b) => b.ratio - a.ratio);

    const active = new Set(ranked.slice(0, this.maxPlaying).map((item) => item.player));

    this.players.forEach((player) => {
      if (active.has(player)) {
        player.play();
      } else {
        player.pause();
      }
    });
  }
}

if (!window.customElements.get('js-instagram')) {
  window.customElements.define('js-instagram', JsInstagram);
}
